// src/admin/EditEventModal.js

import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { db } from '../config/firebaseConfig';
import { doc, updateDoc } from 'firebase/firestore';

const EditEventModal = ({ show, handleClose, event, onEventUpdate }) => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // When the 'event' prop changes, update the form data
  useEffect(() => {
    if (event) {
      setFormData({
        name: event.name || '',
        location: event.location || '',
        date: event.date || '',
        time: event.time || '',
      });
    }
  }, [event]);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Handle form submission to update the event
  const handleSaveChanges = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (!event || !event.id) {
        setError("No event selected to update.");
        setLoading(false);
        return;
    }

    try {
      const eventRef = doc(db, 'events', event.id);
      await updateDoc(eventRef, formData);
      
      // Notify parent component of the update
      onEventUpdate({ ...event, ...formData });
      
      handleClose(); // Close the modal
    } catch (err) {
      console.error("Error updating event: ", err);
      setError("Failed to save changes. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Don't render anything if the event data is not available
  if (!event) return null;

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Event</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSaveChanges}>
        <Modal.Body>
          {error && <div className="alert alert-danger">{error}</div>}
          <Form.Group className="mb-3">
            <Form.Label>Event Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Location</Form.Label>
            <Form.Control
              type="text"
              name="location"
              value={formData.location}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Date</Form.Label>
            <Form.Control
              type="text"
              name="date"
              value={formData.date}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Time</Form.Label>
            <Form.Control
              type="text"
              name="time"
              value={formData.time}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <p className="text-muted small">Note: Poster image cannot be edited from here.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? 'Saving...' : 'Save Changes'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default EditEventModal;